import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getDatasetCount, getOrganizations, getGroups } from "../../../services/CkanApiService";
import { getBpsDatasetCount, getBpsOrganizations } from "../../../services/BpsApiService";

const AboutComponentOpenData = () => {
    const [datasetCount, setDatasetCount] = useState(0);
    const [organizationCount, setOrganizationCount] = useState(0);
    const [categoriesCount, setCategoriesCount] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {

                // CKAN
                const [ckanDataset, ckanOrgs, ckanGroups] = await Promise.all([
                    getDatasetCount(),
                    getOrganizations(),
                    getGroups(),
                ]);
                // BPS
                const bpsDatasets = await getBpsDatasetCount();
                // const bpsDatasets = await getBpsDatasetCount();
                // // Gabungkan API CKAN + BPS
                setDatasetCount((ckanDataset || 0) + (bpsDatasets || 0));
                // Karena BPS hanya untuk "Sampang", jumlah organisasinya sudah pasti +1
                setOrganizationCount((ckanOrgs.length || 0) + 1);
                setCategoriesCount(ckanGroups.length || 0);
                // setDatasetCount((ckanDataset || 0) + (bpsDatasets || 0));
                // setOrganizationCount((ckanOrgs.length || 0) + (bpsOrgs.filter(o => o.domain_name === "Sampang").length || 0));
                // setCategoriesCount((ckanGroups.length || 0));
                
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };

        fetchData();
    }, []);

    return (
        <section id="about_open_data" className="p-t-0 p-b-0">
            <div className="data-hero">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="row">
                                <div className="col-md-4 text-center border-dashed-right">
                                    <Link to={'/open_data/kumpulan_data'} data-aos="fade-left">
                                        <h4>Dataset</h4>
                                        <h1 className="font-weight-700">{datasetCount}</h1>
                                    </Link>
                                </div>
                                <div className="col-md-4 text-center border-dashed-right">
                                    <Link to={'/open_data/organisasi'} data-aos="fade-in">
                                        <h4>Organisasi</h4>
                                        <h1 className="font-weight-700">{organizationCount}</h1>
                                    </Link>
                                </div>
                                <div className="col-md-4 text-center">
                                    <Link to={'/open_data/kategori'} data-aos="fade-right">
                                        <h4>Kategori</h4>
                                        <h1 className="font-weight-700">{categoriesCount}</h1>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row content">
                    <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                        <img src={`${process.env.PUBLIC_URL}/template/img/features.svg`} className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-8 pt-5 order-2 order-md-1" data-aos="fade-up">
                        <h2 className="flex-content"><i className="bx bxs-data mr-1"></i><b> Open Data Sampang</b></h2>
                        <br />
                        <h3>Apa itu Open Data?</h3>
                        <p className="font-size-medium font-weight-100">
                            Website Open Data Sampang adalah portal yang menyediakan akses ke berbagai Dataset terbuka yang berkaitan dengan berbagai aspek kehidupan di Kabupaten Sampang, seperti
                        </p>
                        <div className="details">
                            <div className="content">
                                <ul className="font-size-medium font-weight-100">
                                    <li><i className="bi bi-check"></i> Pemerintah</li>
                                    <li><i className="bi bi-check"></i> Lingkungan</li>
                                    <li><i className="bi bi-check"></i> Transportasi</li>
                                    <li><i className="bi bi-check"></i> Pendidikan</li>
                                    <li><i className="bi bi-check"></i> dan lain-lain</li>
                                </ul>
                            </div>
                        </div>
                        <p className="font-size-medium font-weight-100">
                            Melalui website ini, masyarakat dapat mengakses data secara gratis dan menggunakan informasi tersebut untuk berbagai tujuan, termasuk riset, pengembangan aplikasi, pengambilan keputusan, dan lainnya.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutComponentOpenData;